<!-- =========================================================================================
  File Name: QnAList.vue
  Description: QnA List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.header-custome {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.knowlg-base-wrap-sec a {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 12px;
}
.knowlg-base-wrap-sec a span{margin-right: 10px; line-height: 0;}
.single-row{width: 100%; display: flex; justify-content: space-between;align-items: center;}
.action-sec{justify-content: flex-end;}
.moderation-top .vs__dropdown-toggle {width: 320px;}
.bottom-area-qna-mod{width: 100%; display: flex; justify-content: space-between;align-items: center;}
.width-area {width: 120px;}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>QnA Moderation</h3>
      <div class="knowlg-base-wrap-sec">
        <a href="/pages/knowledge-base/category-qnas/question-2"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></span> Need help with this section?</a>
      </div>
    </div>    
    

    <div class="vx-card p-6">
      <div class="vx-row">
        <div class="vx-col md:w-6/12 w-full">
          <v-select class="sm:mr-4 mr-0 sm:w-auto sm:order-normal order-3 sm:mt-0 mt-4" label="Name" v-model="Session" :options="sessionList" placeholder="Select Session" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-2/12 w-full">
          <vs-tabs  alignment="fixed" v-model="selectedTab" >
            <vs-tab :key="1" label="Approve" @click="getListData('Approve')"></vs-tab>
            <vs-tab :key="2" label="Publish" @click="getListData('Publish')"></vs-tab>
          </vs-tabs>
        </div>
      </div>
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="moderation-top w-full">
          <div class="vx-row">
            <div class="vx-col md:w-12/12 w-full flex action-sec">
              <!--ADD QnA-->
              <vs-button :disabled="addQuestinDisable" class="mr-4" color="rgb(76, 139, 246)" type="filled" v-on:click="popupActive3=true; checkAutoPublishApprovedQuestion();">Add Question</vs-button>
              <vs-popup class="holamundo" title="Add New Question" :active.sync="popupActive3">
                <div class="vx-col md:w-1/1 w-full">
                  <label>Question</label>
                  <vs-input class="w-full" v-model="qnaValue.Question" v-validate="'required'" name="Question" />
                  <span class="text-danger text-sm"  v-show="errors.has('Question')">{{ errors.first('Question') }}</span>
                </div>
                <div class="vx-col md:w-1/1 w-full">
                  <label>Attendee</label>
                  <v-select class="w-full" label="Name" v-model="Attendee" :disabled="qnaValue.IsAnonymous" :options="attendeeList" v-validate="qnaValue.IsAnonymous?'':'required'" name="Attendee"  />
                  <span class="text-danger text-sm"  v-show="errors.has('Attendee')">{{ errors.first('Attendee') }}</span>
                </div>
                <br />
                <div class="single-row">
                  <label for>Submit Anonymously</label>
                  <vs-switch @change="Attendee=null" v-model="qnaValue.IsAnonymous" />
                </div>
                <br />
                <div class="single-row">
                  <label for>Approved</label>
                  <vs-switch @change="checkAutoPublishApprovedQuestion" v-model="qnaValue.Approved" />
                </div>
                <br />
                <div class="single-row">
                  <label for>Published</label>
                  <vs-switch v-model="qnaValue.IsPublished" :disabled="AutoPublishApprovedQuestion ? true : false" />
                </div>
                <br />          
                
                <vs-button color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="before_save">Save</vs-button>
              </vs-popup>
               <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                <vs-input
                  class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                  v-model="searchQuery"
                  @input="updateSearchQuery"
                  placeholder="Search..."
                />

                <!-- ACTION - DROPDOWN -->
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div
                    class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
                  >
                    <span class="mr-2 leading-none">Actions</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>

                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="changeStatus(true, 'IsPublished')">
                      <span class="flex items-center">
                        <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                        <span>Publish</span>
                      </span>
                    </vs-dropdown-item>

                    <vs-dropdown-item @click="changeStatus(false, 'IsPublished')">
                      <span class="flex items-center">
                        <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                        <span>Unpublish</span>
                      </span>
                    </vs-dropdown-item>
                    <!--
                    <vs-dropdown-item @click="changeStatus(true, 'Approved')">
                      <span class="flex items-center">
                        <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                        <span>Approve</span>
                      </span>
                    </vs-dropdown-item>

                    <vs-dropdown-item @click="changeStatus(false, 'Approved')">
                      <span class="flex items-center">
                        <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                        <span>Unapprove</span>
                      </span>
                    </vs-dropdown-item>
                    -->
                  </vs-dropdown-menu>
                </vs-dropdown>
            </div>
          </div>
        </div>
        
        
        
       
        
        <!-- <vs-button color="primary" type="border" class="ml-3 setting-btn" @click="getSettings">
          <img src="../../assets/images/settings.svg" alt="settings" />
        </vs-button> -->
        <vs-popup class="holamundo" title="QnA Option" :active.sync="popupActive2">
          <div class="single-row">
            <label for>Display qnas in Attendee list</label>
            <vs-switch v-model="settingsData.ShowInAttendee" />
          </div>
          <br />
          <div class="single-row">
            <label for>Display Filter Option</label>
            <vs-switch v-model="settingsData.ShowFilter" />
          </div>
          <br />
          <div class="single-row">
           <label for>Display Meeting Button</label>
            <vs-switch v-model="settingsData.ShowMeetingButton" />
          </div>
          <br />
          <div class="single-row">
           <label for>Display Search Option</label>
            <vs-switch v-model="settingsData.ShowSearch" />
          </div>
          <br />
          <div class="single-row">
            <label for>Display Send Message Button</label>
            <vs-switch v-model="settingsData.ShowSendMessageButton" />
          </div>
          <br />
          
          <vs-button color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="saveSettings">Save</vs-button>
        </vs-popup>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="qnasData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>
        <div class="bottom-area-qna-mod">
          <div class="flex-grow">
            <vs-dropdown vs-trigger-click class="cursor-pointer width-area">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span
                  class="mr-2"
                >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ qnasData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : qnasData.length }} of {{ qnasData.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                  <span>30</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
        </div>
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from 'moment-timezone'

// Store Module
import moduleQnAManagement from "@/store/qna-management/moduleQnAManagement.js";
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";
import ls from "@/common/localStorage";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActionsP from "./cell-renderer/CellRendererActionsP.vue";

let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id")
let Session_EventStartDate = ls.getSessionValueByKey("Session_EventStartDate")
let Session_EventEndDate = ls.getSessionValueByKey("Session_EventEndDate")
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ")

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActionsP
  },
  data() {
    return {
      selectedTab:2,
      sessionList: [],
      attendeeList: [],
      Session: {
        Name: 'Select Session',
        SessionId: null
      },
      AutoPublishApprovedQuestion: false,
      Attendee: null,
      settingsData: { ShowInAttendee: false },
      qnaValue: {
        Answer: '',        
        Approved: false,
        IsPublished: false,
        Question: null
      },
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" }
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" }
      ],
      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      popupActive3: false,
      addQuestinDisable: false,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "",
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          width: 50,
          pinned: "left"
        },
        {
          headerName: "Question",
          field: "Question",
          filter: true,
          //cellRendererFramework: "CellRendererLink",
          width: 300,
          pinned: "left"
        },
        {
          headerName: "Posted Date",
          field: "CreatedDate",
          cellRenderer: data => {
            return data.value ? this.SetTimeByZone(new Date(data.value.seconds * 1000).toUTCString(),Session_Event_TZ): '';
          },
          filter: true,
          width: 200
        },
        {
          headerName: "Posted By",
          field: "Name", 
          /*cellRenderer: data => {
            return data.value ? this.getUserDetailById(data.value): '';
          }, */        
          filter: true
        },
        {
          headerName: "Approved",
          field: "Approved",
          //checkboxSelection: true,
          cellRenderer: data => {
            return data.value ? 'Yes' : 'No';
          },  
          filter: true
        },
        {
         headerName: "Answered",
         field: "Answered",
         cellRenderer: data => {
            return data.value ? 'Yes' : 'No';
          },
         filter: true
        },
        {
          headerName: "Likes",
          field: "TotalLikes",
          /*cellRenderer: params => {
            return this.getLikes(params.data.QnAId, params.data.SessionId);
          }, */ 
          filter: true
        },        
        {
          headerName: "Publish",
          field: "transactions",
          cellRendererFramework: "CellRendererActionsP",
          //width: 100,
          cellRendererParams: params => {
            return { id: params.data.QnAId, SessionId: params.data.SessionId, Approved:params.data.Approved };
          }
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActionsP
      }
    };
  },
  watch:{
    "qnaValue.IsPublished"(val) {
      if(val)
        this.qnaValue.Approved = true
    },
    Session(val){
      this.$store.dispatch("qnaManagement/fetchQnAsP", val)
      this.addQuestinDisable = val.SessionTypeDetails.EnableLiveQnA ? false : true
    }
  },
  computed: {
    qnasData() {
      return this.$store.state.qnaManagement.qnasp;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    checkAutoPublishApprovedQuestion(){
      let AutoPublishApprovedQuestion = this.Session && this.Session.SessionTypeDetails && this.Session.SessionTypeDetails.QnAAutoPublish ? true : false
      this.AutoPublishApprovedQuestion = (this.qnaValue.Approved && AutoPublishApprovedQuestion ? true : false)
      this.qnaValue.IsPublished = this.qnaValue.Approved && AutoPublishApprovedQuestion ? true : false
    },
    getListData(tab){
      if(tab == 'Publish')
        this.$router.push("/event/qnalistp/");
      else
        this.$router.push("/event/qnalist/");
    },
    getSettings() {
      this.$vs.loading();

      this.$store.dispatch("qnaManagement/getSettings").then(res => {
        this.settingsData = res;
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("qnaManagement/saveSettings", {
          settingsData: this.settingsData
        })
        .then(res => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message
          });
          this.$vs.loading.close();
        });
    },
    addRecord() {
      this.$router.push("/event/qna/add").catch(() => {});
    },
    editRecord() {
      this.$router.push(`/qna/edit/${268}`).catch(() => {});
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all"
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
     SetTimeByZone : function(strDateTime, timeZone)
    {  
        var date = moment.tz(strDateTime, timeZone).format('MM/DD/YYYY HH:mm');
        return date
    },
  GetTimeByZone : function(strDateTime, timeZone)
    {
      
      strDateTime = moment(strDateTime).format('YYYY-MM-DD HH:mm')
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);      
      return strtDate._d;      
    }, 
    GetDateTimeFromSeconds(seconds) {
      //var myObj = $.parseJSON('{"date_created":\""+seconds.toString()+"\"}');
      var myDate = new Date(1000 * seconds);
      //console.log(myDate.toString());
      //console.log(myDate.toLocaleDateString("en-IN"));
      return myDate.toUTCString();
      //return myDate.toLocaleString();
      //return myDate.toLocaleDateString("en-US");
    },
    UploadQnA: function() {
      var files = document.getElementById("qna_file").files;
      bu.initVueComps(this.$vs)
      bu.StartUploadPrecss(files,'qna');
    },
    changeStatus(Status, fieldName) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("qnaManagement/changeStatus", {
            data: selectedRows,
            Status: Status,
            fieldName: fieldName
          })
          .then(res => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("qnaManagement/fetchQnAsP");
          })
          .catch(err => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK"
        });
      }
    },    
    getSessions(){ 
      let firstSessionFound = false
      this.$store
          .dispatch("sessionManagement/fetchSessions")
          .then(res => { 
            res = res.sort((a, b) => {
                let fa = a.Name.toLowerCase(),
                    fb = b.Name.toLowerCase();

                if (fa < fb) {
                    return -1;
                }
                if (fa > fb) {
                    return 1;
                }
                return 0;
            });

            for(let i=0;i<res.length;i++)
            {
              //if(res[i].SessionTypeDetails.QnAModeration)
              //{
                this.sessionList.push(res[i])
                if(!firstSessionFound)
                {
                  this.Session = res[i] 
                  firstSessionFound = true
                }
              //}
            } 
          })
    },
    getAttendees(){
      this.$store
          .dispatch("attendeeManagement/fetchAttendees")
          .then(res => {              
            for(let i=0;i<res.length;i++)
            {
              if(res[i].IsPublished)
                this.attendeeList.push(res[i])
            } 
          })
    },
    before_save()
    {
      return new Promise((resolve, reject) => {
          this.$validator.validateAll().then(result => {
          resolve(result);
          if (result) this.addQuestion();
        })
      })
    },
    addQuestion(){
      this.popupActive3 = false;
      if(this.Session && this.Session.SessionId)
      {
        this.$vs.loading();
        this.$store
          .dispatch("qnaManagement/addQuestion", {qnaValue: this.qnaValue, Session: this.Session, Attendee: this.Attendee })
          .then(res => {   
          this.$vs.loading.close();           
           this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Question",
                text: "Question created successfully.",
              });
          this.$store.dispatch("qnaManagement/fetchQnAsP")
          }).catch(function(error) { console.log(error) })
      }
      else
      {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Question",
          text: "Please Select Session",
          acceptText: "OK"
        });
      }
    }    
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleQnAManagement.isRegistered) {
      this.$store.registerModule("qnaManagement", moduleQnAManagement);
      moduleQnAManagement.isRegistered = true;
    }
    this.$store.dispatch("qnaManagement/fetchQnAsP", null).catch(err => {
      console.error(err);
    });
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule("attendeeManagement", moduleAttendeeManagement);
      moduleAttendeeManagement.isRegistered = true;
    }
    this.getSessions();
    this.getAttendees();
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>